export default __webpack_public_path__ + "static/media/discuter.74259235.png";